/* src/app/workshop/components/defects/new-defect/new-defect.component.scss */
/*# sourceMappingURL=new-defect.component.css.map */
